import React from 'react';
import { Box, EmployerDashboardSpendPlaceholderIcon, RawButton, Text } from '@common-fe/common-fe';
interface Props {
  onTryAgain?: () => void;
  children?: React.ReactNode;
}
const EmployerSectionPlaceholder: React.FC<Props> = ({ onTryAgain, children }) => {
  return (
    <Box
      round="container2Round"
      align="center"
      justify="center"
      pad="spacing24"
      width="100%"
      height="180px"
      background="canvas"
      border={{ size: '1px', color: 'border2' }}
      data-testid="employer-section-placeholder"
    >
      <EmployerDashboardSpendPlaceholderIcon size="72px" color="iconDisabled" />

      <Text size="medium" weight={700} margin={{ vertical: 'spacing8' }}>
        {children || "We couldn't load your balance data"}
      </Text>
      {!!onTryAgain && (
        <RawButton onClick={onTryAgain} data-testid="employer-section-placeholder_try-again-button">
          <Box pad={{ vertical: 'spacing6', horizontal: 'spacing16' }}>
            <Text color="textAccent" size="medium" weight={400}>
              Try Again
            </Text>
          </Box>
        </RawButton>
      )}
    </Box>
  );
};

export default EmployerSectionPlaceholder;
